import { FIELD_UNITS, SetupCall } from '@driscollsinc/driscolls-display-rules';
import { dateTimeSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        'VatRateMaintenance',
        [
            {
                name: 'VATPercentID',
                type: FIELD_UNITS.RAW
            },
            {
                name: 'Country',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'BusinessUnit',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'State',
                type: FIELD_UNITS.STRING
            },
            {
                name: 'VATPercent',
                type: FIELD_UNITS.NUMBER,
                options: { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            },
            {
                name: 'EffectiveStartDate',
                type: FIELD_UNITS.DATE
            },
            {
                name: 'EffectiveEndDate',
                type: FIELD_UNITS.DATE
            },
            {
                name: 'EndDateActive',
                type: FIELD_UNITS.DATE
            },
            {
                name: 'StartDateActive',
                type: FIELD_UNITS.DATE
            },
            ...dateTimeSetupFields
        ],
        {}, //options
        (data) => {
            console.log('Vat Rate Maintenance REDUCER-- ', data);
        }
    );
}

const VatRateMaintenance = {
    configureSetupCall
};

export default VatRateMaintenance;
